<template>
  <!-- 消费明细页面 -->
  <div class="consumptionDetailPage">
    <!-- 订单列表 -->
    <section class="orderListWrap">
      <van-divider v-if="!cardData.length && !isShowLoad" dashed :style="{ color: '#ddd', borderColor: '#ccc', padding: '0 16px' }"
        >无消费明细数据
      </van-divider>
      <OrderCard :data="cardData" :hiddenPrice="true" @click="clickCard" @refresh="init" />
    </section>
    <div v-show="isShowLoad" class="loadBox">
      <van-loading size="30px" vertical color="#333"
        ><span style="color:#333">{{ loadingTxt ? `${loadingTxt}...` : '加载中...' }}</span>
      </van-loading>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { Toast } from 'vant'
import { useRouter } from 'vue-router'
import OrderCard from '@/components/order/OrderCard'
import { reorganizeConsumptionListData } from '@/util/order/handle'
import { getLoyaltyPlanUseCouponList } from '@/api/order'

export default {
  name: 'consumptionDetail',
  components: {
    OrderCard
  },
  setup() {
    const router = useRouter()
    const query = router.currentRoute.value.query
    const state = reactive({
      loyaltyId: query.loyaltyId,
      gsCode: query.gsCode,
      customerPlanId: query.customerPlanId,
      query,
      cardData: [], // 展示数据
      isShowLoad: false,
      loadingTxt: ''
    })

    // 设置loading
    const setLoading = (isShowLoad = false, loadingTxt = '') => {
      state.isShowLoad = isShowLoad
      state.loadingTxt = loadingTxt
    }

    // 初始化
    const init = async () => {
      setLoading(true)
      state.cardData = []
      try {
        const { list: listData } = await getLoyaltyPlanUseCouponList({
          pageSize: 1000,
          pageNo: 1,
          customerPlanId: state.customerPlanId,
          loyaltyId: state.loyaltyId,
          gsCode: state.gsCode
        })
        state.cardData = reorganizeConsumptionListData(listData)
        setLoading()
      } catch (e) {
        Toast({
          message: e.message || '请求消费明细数据失败',
          position: 'bottom'
        })
        setLoading()
      }
    }

    // 点击列表卡片内容
    const clickCard = item => {
      // console.log("clickCard-->", item);
      router.push({
        path: '/orderDetail',
        query: { orderId: item.id, event: '订单详情', from: 'consumption' }
      })
    }

    onMounted(() => {
      init()
    })

    return {
      ...toRefs(state),
      setLoading,
      init,
      clickCard
    }
  }
}
</script>

<style lang="scss" scoped>
.consumptionDetailPage {
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
}
.orderListWrap {
  margin-top: 16px;
}
.loadBox {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding-top: 250px;
  background-color: rgba($color: #000000, $alpha: 0.4);
  z-index: 1000;
}
</style>
